import { getDaffyFetchOptions } from '~/helpers/api';
import { fetchJwtToken } from './fetchTokens';
import { getTimezoneAuthData } from '~/dashboard/views/authentication/helpers';
import log from '~/helpers/logging';

type Params = {
  currentCell: string; cellHostUrl: string; targetCell: string; path: string;
};

/**
 * handleNavigation - handles authenticated navigation on selected customer
 */
export const handleNavigation = async ({
  currentCell,
  cellHostUrl,
  targetCell,
  path,
}: Params) => {
  if (currentCell !== targetCell) {
    const jwtToken = await fetchJwtToken();

    const response = await fetch(`${cellHostUrl}/v2/login/oauth/jwt/`, {
      ...getDaffyFetchOptions({
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(getTimezoneAuthData()),
      }),
      credentials: 'include',
    });
    const jsonResp = await response.json();

    if (jsonResp?.result === 'success') {
      window.location.assign(`${cellHostUrl}${path}`);
    } else {
      log('error', 'Error login with JWT token', {}, jsonResp.Error);
    }
  } else {
    window.location.assign(`${cellHostUrl}${path}`);
  }
};
